import * as React from 'react';
import { NativeAdObj } from '../../../shared/types/ast';
import { logClick, AdditonalEventContext } from '../../utils/logger';

type Props = {
    adObj: NativeAdObj;
    className?: string;
    style?: React.CSSProperties;
    additionalEventContext?: AdditonalEventContext;
    dangerouslySetInnerHTML?: { __html: string };
    children: React.ReactNode;
};

function getClassName(className?: string) {
    return `${className ? `${className} ` : ''}linkblock dark-links clickable`;
}

// TODO: Check if we can use noreferrer on the links
/* eslint-disable react/jsx-no-target-blank */
const Link = React.forwardRef(function Button(
    {
        adObj,
        adObj: { native },
        className,
        style,
        additionalEventContext,
        dangerouslySetInnerHTML,
        children,
    }: Props,
    ref: React.Ref<HTMLAnchorElement>,
) {
    return (
        <a
            ref={ref}
            href={native.clickUrl}
            className={getClassName(className)}
            style={style}
            dangerouslySetInnerHTML={dangerouslySetInnerHTML}
            target="_blank"
            rel="noopener"
            onClick={() => {
                logClick(adObj.targetId, adObj, additionalEventContext);
            }}
        >
            {children}
        </a>
    );
});
/* eslint-enable react/jsx-no-target-blank */

export default Link;
